const urlifyGroupName = (groupName: string): string => `/${groupName.replace(new RegExp('[^a-zA-Z0-9]', 'g'), '')}`.toLowerCase()

export default urlifyGroupName
